import { CompanyProductSelection, CompanyProductSelectionDTO } from '@iota/iota-management-portal-v4-client';
import { createAction, props } from '@ngrx/store';
import { AttributeListResult } from 'src/app/shared/components/attribute-list/attribute-list.component';

export enum CompanyProductSelectionActionTypes {
    LoadCompanyProductSelectionsByCompany = '[CompanyProductSelection] LoadCompanyProductSelectionsByCompany',
    LoadCompanyProductSelectionsSuccess = '[CompanyProductSelection] LoadCompanyProductSelectionsSuccess',
    LoadCompanyProductSelectionsFailure = '[CompanyProductSelection] LoadCompanyProductSelectionsFailure',

    ReloadCompanyProductSelectionsByIds = '[CompanyProductSelection] ReloadCompanyProductSelectionsByIds',
    ReloadCompanyProductSelectionsByIdsSuccess = '[CompanyProductSelection] ReloadCompanyProductSelectionsByIdsSuccess',

    AddUpdateRemoveCompanyProductSelection = '[CompanyProductSelection] AddUpdateRemoveCompanyProductSelection',
    AddUpdateRemoveCompanyProductSelectionSuccess = '[CompanyProductSelection] AddUpdateRemoveCompanyProductSelectionSuccess',

    AddUpdateRemoveCompanyProductSelectionAttributes = '[CompanyProductSelection] AddUpdateRemoveCompanyProductSelectionAttributes',

    CompanyProductSelectionActionFailure = '[CompanyProductSelection] CompanyProductSelectionActionFailure',

    SaveLatestCompanyProductSelectionIdsAndLoadCompanyProductSelectionsByCompany = '[CompanyProductSelection] SaveLatestCompanyProductSelectionIdsAndLoadCompanyProductSelectionsByCompany',
    ClearLatestCompanyProductSelectionIds = '[CompanyProductSelection] ClearLatestCompanyProductSelectionIds'
}

export const SaveLatestCompanyProductSelectionIdsAndLoadCompanyProductSelectionsByCompany = createAction(
    CompanyProductSelectionActionTypes.SaveLatestCompanyProductSelectionIdsAndLoadCompanyProductSelectionsByCompany,
    props<{ companyId: string; latestCompanyProductSelectionIds: string[] }>()
);
export const ClearLatestCompanyProductSelectionIds = createAction(CompanyProductSelectionActionTypes.ClearLatestCompanyProductSelectionIds);

export const ReloadCompanyProductSelectionsByIds = createAction(
    CompanyProductSelectionActionTypes.ReloadCompanyProductSelectionsByIds,
    props<{ companyProductSelectionIds: string[] }>()
);
export const ReloadCompanyProductSelectionsByIdsSuccess = createAction(
    CompanyProductSelectionActionTypes.ReloadCompanyProductSelectionsByIdsSuccess,
    props<{ productSelections: CompanyProductSelection[] }>()
);

export const AddUpdateRemoveCompanyProductSelectionAttributes = createAction(
    CompanyProductSelectionActionTypes.AddUpdateRemoveCompanyProductSelectionAttributes,
    props<{
        attributeResult: AttributeListResult;
        companyProductSelectionId: string;
    }>()
);

export const AddUpdateRemoveCompanyProductSelection = createAction(
    CompanyProductSelectionActionTypes.AddUpdateRemoveCompanyProductSelection,
    props<{
        upsertedProductSelections?: CompanyProductSelectionDTO[];
        removedProductSelections?: string[];
    }>()
);
export const AddUpdateRemoveCompanyProductSelectionSuccess = createAction(
    CompanyProductSelectionActionTypes.AddUpdateRemoveCompanyProductSelectionSuccess
);

export const CompanyProductSelectionActionFailure = createAction(
    CompanyProductSelectionActionTypes.CompanyProductSelectionActionFailure,
    props<{ error: any }>()
);

export const LoadCompanyProductSelectionsByCompany = createAction(
    CompanyProductSelectionActionTypes.LoadCompanyProductSelectionsByCompany,
    props<{ companyId: string }>()
);
export const LoadCompanyProductSelectionsSuccess = createAction(
    CompanyProductSelectionActionTypes.LoadCompanyProductSelectionsSuccess,
    props<{ productSelections: CompanyProductSelection[]; companyId: string }>()
);
export const LoadCompanyProductSelectionsFailure = createAction(
    CompanyProductSelectionActionTypes.LoadCompanyProductSelectionsFailure,
    props<{ error: any }>()
);
